<template>
  <div class="index" >
    <el-container>
<!--      <el-badge :value="100" :max="10" class="item right" @click.native="shop_cart">-->
<!--        <span class="el-icon-shopping-cart-full" style="font-size: 25px"></span>-->
<!--      </el-badge>-->

      <el-header style="padding-left: 200px; padding-right: 0px">
        <el-menu
          background-color="#7A8B8B"
          text-color="#fff"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#ffd04b"
        >
          <el-menu-item index="1">
            <router-link :to="{ name: 'admin' }"> 首页概况</router-link>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">我的工作台</template>
            <el-menu-item index="2-1" @click="logout">退出</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-header>
      <el-container>

        <el-aside width="200px">
            {{route_list}}
            {{menu_list}}
          <el-menu :default-openeds="show_path" ref="nav_menu" @select="select_menu" @close="close_menu" >

              <el-submenu :index="index+'_'+item.id" v-for="(item,index) in menu_list" :key="index+'_'+item.id"   >
                  <template slot="title"><i class="el-icon-ship"></i>{{ item.title }}</template>

                  <el-menu-item :index="index+'_'+item.id+'_'+item1.id" v-for="(item1,index1) in item.children" :key="index1+'_'+item1.id"  >
                      <router-link :to="{ name: item1.name }"> {{item1.title}}</router-link>
                  </el-menu-item>


              </el-submenu>
            <el-submenu index="1"   >
              <template slot="title"><i class="el-icon-ship"></i>商品管理</template>

              <el-menu-item index="1-1">
                <router-link :to="{ name: 'goods_index' }"> 商品列表</router-link>
              </el-menu-item>

              <el-menu-item index="1-2">
                <router-link :to="{ name: 'goods_add' }"> 添加商品</router-link>
              </el-menu-item>
            </el-submenu>
              <el-submenu index="9">
                  <template slot="title"><i class="el-icon-suitcase"></i>商品组</template>


                  <el-menu-item index="9-2">
                      <router-link :to="{ name: 'product_group_index' }"> 添加组</router-link>
                  </el-menu-item>
              </el-submenu>
            <el-submenu index="2">
              <template slot="title"><i class="el-icon-shopping-bag-1"></i>属性管理</template>

              <el-menu-item index="2-1">
                <router-link :to="{ name: 'attr_add' }"> 添加属性</router-link>
              </el-menu-item>
              <el-menu-item index="2-2">
                <router-link :to="{ name: 'category_add' }"> 添加分类</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title"><i class="el-icon-notebook-1"></i>代理设置</template>

              <el-menu-item index="3-1">
                <router-link :to="{ name: 'admin' }"> 代理商概况</router-link>
              </el-menu-item>

              <el-menu-item index="3-2">
                <router-link :to="{ name: 'agent_setup' }"> 代理商设置</router-link>
              </el-menu-item>
              <el-menu-item index="3-3">
                <router-link :to="{ name: 'agent_price' }"> 商品价格</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title"><i class="el-icon-message"></i>代理管理</template>

              <el-menu-item index="4-1">
                <router-link :to="{ name: 'agent_user_index' }"> 代理列表</router-link>
              </el-menu-item>

              <el-menu-item index="4-2">
                <router-link :to="{ name: 'agent_user_add' }"> 新建代理</router-link>
              </el-menu-item>
              <!-- <el-menu-item>
                <router-link :to="{ name: 'purchase_order' }"> 采购商品</router-link>
              </el-menu-item>
              <el-menu-item index="3-3">
                <router-link :to="{ name: 'Order_My_Index' }"> 我的采购单</router-link>
              </el-menu-item> -->
            </el-submenu>

            <el-submenu index="5">
              <template slot="title"><i class="el-icon-present"></i>代理订单</template>
              <el-menu-item index="5-1">
                <router-link :to="{ name: 'order_all_index' }"> 所有订单 </router-link>
              </el-menu-item>
              <el-menu-item index="5-2">
                <router-link :to="{ name: 'order_service' }">售后订单</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="6">
              <template slot="title"><i class="el-icon-suitcase"></i>结算管理</template>
              <el-menu-item index="6-1"
                ><router-link :to="{ name: 'order_profits_index', params: { status: 0 } }"
                  >未结算订单</router-link
                ></el-menu-item
              >
              <el-menu-item index="6-2">
                <router-link :to="{ name: 'order_profits_index', params: { status: 1 } }"
                  >已结算订单</router-link
                ></el-menu-item
              >
              <el-menu-item index="6-3">
                <router-link :to="{ name: 'withdrawal_index' }">
                  提现记录
                </router-link></el-menu-item
              >
              <el-menu-item index="6-1">
                <router-link :to="{ name: 'payment_index' }">
                  收支明细</router-link
                ></el-menu-item
              >
                <el-menu-item index="6-4">
                    <router-link :to="{ name: 'recharge_index' }"> 用户充值 </router-link>
                </el-menu-item>
            </el-submenu>
              <el-submenu index="7">
                  <template slot="title">
                      <i class="el-icon-collection"></i>权限管理</template
                  >

                  <el-menu-item index="7-1"
                  ><router-link :to="{ name: 'roles_add' }"
                  >角色管理</router-link
                  ></el-menu-item
                  >
                  <el-menu-item index="7-2"
                  ><router-link :to="{ name: 'menu_index' }"
                  >菜单管理</router-link
                  ></el-menu-item
                  >
                  <el-menu-item index="7-3"
                  ><router-link :to="{ name: 'password_index' }"
                  >权限配置</router-link
                  ></el-menu-item
                  >
              </el-submenu>
              <el-submenu index="8">
                  <template slot="title">
                      <i class="el-icon-truck"></i>快递管理</template
                  >
                  <el-menu-item index="8-1"
                  ><router-link :to="{ name: 'express_index' }"
                  >快递列表</router-link
                  ></el-menu-item
                  >

              </el-submenu>
            <el-submenu index="9">
              <template slot="title">
                <i class="el-icon-postcard"></i>我的账户</template
              >
              <el-menu-item index="9-1"
                ><router-link :to="{ name: 'password_index' }"
                  >重置密码</router-link
                ></el-menu-item
              >
            </el-submenu>

            <!-- <el-submenu index="6">
              <template slot="title"> <i class="el-icon-setting"></i>统计报表</template>
              <el-menu-item index="6-1"> 代理统计</el-menu-item>
              <el-menu-item index="6-2">结算统计</el-menu-item>
              <el-menu-item index="6-3">团队统计</el-menu-item>
            </el-submenu> -->
          </el-menu>
        </el-aside>
        <el-main>
          <div>
            <slot name="breadcrumb"></slot>
          </div>

          <router-view> </router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
        show_path:['1','2','3'],
        menu_list:{},
        route_list:[]
    };
  },
  methods: {
      ...mapActions({
          getPermissionMenuAction: "getPermissionMenuAction",
      }),
    shop_cart() {
      this.$router.push({
        name: "shop_cart",
      });
    },
    home() {
      this.$router.push({
        name: "index",
      });
    },
    logout() {
      localStorage.removeItem("sh_admin_user_data");
      this.$router.push({
        name: "admin_login",
      });
    },
      close_menu(index,indexPath){

          console.log(index,)

          let path=indexPath[0]

          if(this.show_path.includes(path)){

              // this.show_path.push(path)
              this.show_path.splice(this.show_path.findIndex(item => item === path), 1)

          }
      },
      permissions_menu(){

       console.log("routes",this.$router.options.routes)
      },
      select_menu(index,indexPath){

            console.log(index,)

          let path=indexPath[0]

         if(!this.show_path.includes(path)){

             this.show_path.push(path)
         }
          // this.$refs.nav_menu.open(6)
      }
  },
  mounted() {

      this.permissions_menu()
      this.getPermissionMenuAction({})
  },
  computed: {
        ...mapState({
            result: (state) => state.menu.result,
        }),
    },
    watch: {
        result(val){

            this.menu_list=val
            for(let k in val){

                for(let kk in val[k]['children']){
                    // alert(val[k]['children'][kk]['title'])

                    let component= val[k]['children'][kk]["component"]
                    let item= {
                         meta:{
                         title: val[k]['children'][kk]["title"],
                         requireAuth: val[k]['children'][kk]["requireAuth"]
                     },
                     name: val[k]['children'][kk]["name"],
                     path: val[k]['children'][kk]["path"],
                     component:(resolve)=> require([`${component}`], resolve)

                     // component:() => component),
                     }
                     // this.route_list.push(item)
                    this.$router.options.routes[0]["children"].push(item)

                }


            }
            // this.$router.addRoutes([...this.route_list])

            console.log("aaaa",this.$router.options.routes)

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;

  line-height: 60px;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
}

.el-aside .el-menu-item a,
.el-menu-item a:hover {
  color: inherit;
  font-size: 14px;
  text-decoration: none;
}
.item {
  margin-top: 20px;
  margin-right: 40px;
}

.right {
  right: 10px;
  position: absolute;
  z-index: 99999;
}
</style>
